import styled from "styled-components";
import media from "styled-media-query";

import { Text, Color, ColorV2 } from "@adoptaunabuelo/react-components";
import { Play } from "lucide-react";
import VideoModal from "../modal/VideoModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux";

const Container = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	${media.lessThan("medium")`
        flex-direction: column;
        height: unset;
		min-width: calc(100vw - 48px);
    `};
`;
const Image = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 287px;
	aspect-ratio: 9/16;
	border-radius: 12px;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	overflow: hidden;
	cursor: pointer;
	position: relative;
	${media.lessThan("medium")`
        aspect-ratio: 16/9;
		width: 100%;
		margin-bottom: 16px;
		background-position: center;
    `};
`;
const DataContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	height: 100%;
	padding: 0px 24px;
	${media.lessThan("medium")`
        padding: 0px;
    `};
`;
const DataView = styled.div`
	display: flex;
	flex-direction: column;
`;
const TestimonyView = styled.div`
	position: relative;
	padding: 24px;
	border-radius: 12px;
	background-color: ${ColorV2.surface.background};
	margin-top: 32px;
	margin-bottom: 32px;
	${media.lessThan("medium")`
        margin-top: 24px;
		margin-bottom: 0px;
		padding: 16px;
    `};
`;
const Chip = styled.div`
	display: flex;
	padding: 6px 14px;
	border-radius: 20px;
	border: 1px solid ${ColorV2.border.neutralSoft};
	width: fit-content;
	align-items: center;
	justify-content: center;
	gap: 6px;
	margin-bottom: 24px;
	${media.lessThan("medium")`
    	display: none;
    `};
`;
const ChipMobile = styled.div`
	display: none;
	position: absolute;
	bottom: 12px;
	left: 16px;
	padding: 4px 8px;
	border-radius: 20px;
	border: 1px solid ${ColorV2.border.neutralSoft};
	width: fit-content;
	align-items: center;
	justify-content: center;
	gap: 6px;
	background-color: white;
	${media.lessThan("medium")`
		display: flex;
    `};
`;
const PlayButton = styled.div`
	display: flex;
	width: 64px;
	height: 64px;
	justify-content: center;
	align-items: center;
	border-radius: 56px;
	background: rgba(0, 29, 61, 0.14);
	backdrop-filter: blur(20px);
	${media.lessThan("medium")`
		width: 48px;
		height: 48px;
    `};
`;

const ActivityCell = (props: ActivityCellProps) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [showVideoModal, setShowVideoModal] = useState(false);
	return (
		<Container>
			<VideoModal
				isVisible={showVideoModal}
				url={props.video}
				onClose={() => setShowVideoModal(false)}
			/>
			<Image
				style={{ backgroundImage: `url(${props.img})` }}
				onClick={() => setShowVideoModal(true)}
			>
				<PlayButton>
					<Play
						height={isMobile ? 24 : 32}
						width={isMobile ? 24 : 32}
						color="white"
						fill="white"
					/>
				</PlayButton>
				<ChipMobile>
					{props.label.icon}
					<Text type="p">{props.label.title}</Text>
				</ChipMobile>
			</Image>
			<DataContainer>
				<Chip>
					{props.label.icon}
					<Text type="p">{props.label.title}</Text>
				</Chip>
				<DataView>
					<Text type="p">{props.info}</Text>
				</DataView>
				<TestimonyView>
					<Text type="h6">"{props.testimony}"</Text>
					<Text
						type="p"
						style={{
							fontFamily: "Chantal",
							fontSize: 20,
							lineHeight: "28px",
							marginTop: 16,
							color: Color.text.high,
						}}
					>
						{props.name}
					</Text>
				</TestimonyView>
				{props.children}
			</DataContainer>
		</Container>
	);
};
export default ActivityCell;
export interface ActivityCellProps {
	img: string;
	video: string;
	label: {
		title: string;
		icon: React.JSX.Element;
	};
	testimony: string;
	info: string;
	name: string;
	children?: any;
}
